// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');
export const LIB_VERSION = packageJson.version;
